import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CheckCircleIcon } from 'lucide-react';
export function AudienceSection() {
  const forWhom = [{
    title: 'Profesores de Educación Física',
    desc: 'Que quieren dejar de improvisar y justificar cada ejercicio con criterio.'
  }, {
    title: 'Entrenadores Personales',
    desc: 'Que buscan respaldar sus decisiones con una base técnica sólida.'
  }, {
    title: 'Instructores de Musculación',
    desc: 'Que quieren corregir errores con seguridad y aumentar la confianza de sus alumnos.'
  }];
  return <section className="py-10 relative overflow-hidden bg-background" data-id="element-1">
      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-2">
        <FadeIn className="text-center mb-10" data-id="element-3">
          <h2 className="text-4xl md:text-5xl font-black mb-6 text-gray-900" data-id="element-4">
            Este pack es{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary" data-id="element-5">
              para vos
            </span>
            ?
          </h2>
          <p className="text-xl text-gray-500 max-w-2xl mx-auto" data-id="element-6">
            Diseñado específicamente para quienes se toman en serio su{' '}
            <span className="text-gray-800 font-semibold" data-id="element-7">profesión</span>.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-4" data-id="element-8">
          {forWhom.map((item, index) => <FadeIn key={index} delay={0.2 + index * 0.1} direction="up" data-id="element-9">
              <div className="bg-primary/5 border border-primary/20 rounded-xl p-5 h-full relative overflow-hidden hover:shadow-md transition-all" data-id="element-10">
                <div className="flex items-center gap-3 mb-2" data-id="element-11">
                  <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center shrink-0" data-id="element-12">
                    <CheckCircleIcon className="w-5 h-5 text-primary" data-id="element-13" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900" data-id="element-14">
                    {item.title}
                  </h3>
                </div>
                <p className="text-gray-500 text-sm" data-id="element-15">{item.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}